import { render } from "./Checklist.vue?vue&type=template&id=3f789efd&scoped=true"
import script from "./Checklist.vue?vue&type=script&lang=js"
export * from "./Checklist.vue?vue&type=script&lang=js"

import "./Checklist.vue?vue&type=style&index=0&id=3f789efd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f789efd"]])

export default __exports__